//////////survey  api

const survey = {
  surveys: () => `/survey`,
  get: () => `/survey/GetByToken`,
  getAll: (cId, cType, limit) =>
    `/survey/GetAll?customerId=${cId}&customerType=${cType}&limit=${limit}`,
  submit: () => `/survey/SubmitSurvey`,
  getPupilSurveys: (schoolId, studentId) =>
    `/survey/getPupilSurveys?schoolId=${schoolId}&studentId=${studentId}`,
}

const surveyQuestion = {
  get: id => `/surveyquestion?id=${id}`,
  getByToken: () => `/surveyquestion/GetSurveyQuestionsBySurveyToken`,
}

const participants = {
  checkPasscode: () => 'Participants/CheckPasscode',
  qrCodeVerify: () => 'Participants/QrCodeVerify',
  sendLoginEmail: () => '/participants/AttemptEmailLogin',
  verifyEmailToken: () => '/participants/VerifyEmailToken',
  verifyStudent: () => '/participants/VerifyStudent',
}

const groupCycles = {
  getBySurveyToken: () => `/groupCycle/getBySurveyToken`,
}

const questions = {
  get: id => `/questions?id=${id}`,
  getQuestionForParticipants: () =>
    `/surveyquestion/GetSurveyQuestionByParticipantToken`,
  getListByIds: () => `/questions/GetListByIds`,
  getAll: id => `/questions/getAll`,
  getQuestionsByTagId: (tagId, audience) =>
    `/questions/GetQuestionsByTagId?tagId=${tagId}&audience=${audience}`,
}

export const safeSpace = {
  submitSafeSpaceConversation: `/SafeSpace/AddSafeSpaceConversations`,
  GetSafeSpaceConversationsbyStudentId: `/SafeSpace/GetSafeSpaceConversationsbyStudentId`,
  AddConversationsMessagesReplies: `/SafeSpace/AddSafeSpaceConversationReply`,
  StudentConversationSeen: `/SafeSpace/message/student-seen`,
  // schoolId scopes the responders to this pupil's school. A pupil id is only unique
  // within one school, so without it the API returns the responders of every school
  // that happens to share the id.
  GetStaffByStudentId: (studentId, schoolId) =>
    `/SafeSpace/GetStaffByStudentId?studentId=${studentId}&schoolId=${schoolId}`,
  CheckStudentInSafeSpaceAndHasCheckin: (schoolId, matId, studentId) =>
    `/SafeSpace/CheckStudentInSafeSpaceAndHasCheckin?schoolId=${schoolId}&matid=${matId}&studentId=${studentId}`,
  GetSafeSpaceSettings: (schoolId,groupId,isMAT) =>
    `/SafeSpace/GetSafeSpaceSettings?schoolId=${schoolId}&groupId=${groupId}&isMat=${isMAT}`,
  getHolidays: (schoolId,matId) =>
    `/admin/getHolidays?schoolId=${schoolId}&matId=${matId}`,  
  // afterMessageId asks for only the messages newer than the one given — the tail of a live thread
  // rather than the whole history. Omit it for the initial load.
  getStaffConversationsMessagesById: (conversationId, isMAT, groupId, schoolId, afterMessageId = null) =>
    `/SafeSpace/conversation/messages/${conversationId}?isMAT=${isMAT}&groupId=${groupId}&schoolId=${schoolId}` +
    (afterMessageId != null ? `&afterMessageId=${afterMessageId}` : ''), 
}
const checkin = {
  // studentId, not pupilId. The endpoint binds a parameter called studentId, so sending pupilId
  // left it unset and every pupil was told there was no check-in for them - the survey has never
  // been reachable. Its sibling below really does take pupilId, which is how the two came to differ.
  CheckInAvailableForPupil: (schoolId, matId, studentId) =>
    `/CheckIn/CheckInAvailableForPupil?schoolId=${schoolId}&matId=${matId}&studentId=${studentId}`,
  getCheckInForPupil: (schoolId, matId, pupilId) =>
    `/CheckIn/GetCheckInForPupil?schoolId=${schoolId}&matId=${matId}&pupilId=${pupilId}`,
}

export {groupCycles, participants, questions, survey, surveyQuestion, checkin}
